import React, { useCallback, useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import moment from "moment";
import { getBetHistoryAPI, searchUserAPI } from "../../service/AuthService";

export default function BetHistory() {
  const [from, setFrom] = useState(moment().subtract(7, "days").format("YYYY-MM-DD"));
  const [to, setTo] = useState(moment().format("YYYY-MM-DD"));
  const [sport, setSport] = useState("CRICKET");
  const [matched, setMatched] = useState("MATCHED");
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [userName, setUserName] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadBetHistory = useCallback(async () => {
    setLoading(true);
    const result = await getBetHistoryAPI({
      from: new Date(`${from}T00:00:00`),
      to: new Date(`${to}T23:59:59`),
      matched: matched === "MATCHED",
      page,
      size,
      sport,
      userName: userName?.value,
    });
    const response = result?.response || {};
    const content = Array.isArray(response) ? response : response?.content || [];
    setRows(content.map((item) => ({
      ...item,
      betType: item.back_rate || item.back_run ? "Back" : "Lay",
      userRate: item.back_rate ?? item.lay_rate ?? item.back_run ?? item.lay_run ?? 0,
      profitLoss: item.profit ?? item.loss ?? 0,
    })));
    setTotalPages(Number(response?.totalPages ?? (content.length ? 1 : 0)));
    setLoading(false);
  }, [from, matched, page, size, sport, to, userName]);

  useEffect(() => {
    loadBetHistory();
  }, [loadBetHistory]);

  const searchClient = (inputValue) =>
    searchUserAPI(inputValue).then((result) =>
      (result?.response || []).map((name) => ({ value: name, label: name }))
    );

  return (
    <div className="main bet-history-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 main-container">
            <div className="listing-grid">
              <div className="detail-row">
                <h2>Bet History</h2>
                <div id="form-search" className="report-filter-form">
                  <div className="row">
                    <div className="col-md-2 form-group">
                      <label htmlFor="bet-history-sport">Sports Type</label>
                      <select id="bet-history-sport" className="form-control" value={sport} onChange={(event) => setSport(event.target.value)}>
                        <option value="ALL">All</option><option value="CRICKET">Cricket</option><option value="SOCCER">Football</option><option value="TENNIS">Tennis</option><option value="CASINO">Casino</option>
                      </select>
                    </div>
                    <div className="col-md-2 form-group">
                      <label htmlFor="bet-history-status">Bet Status</label>
                      <select id="bet-history-status" className="form-control" value={matched} onChange={(event) => setMatched(event.target.value)}>
                        <option value="MATCHED">Matched</option><option value="DELETED">Deleted</option>
                      </select>
                    </div>
                    <div className="col-md-2 form-group">
                      <label htmlFor="bet-history-from">From</label>
                      <input id="bet-history-from" className="form-control" type="date" value={from} onChange={(event) => setFrom(event.target.value)} />
                    </div>
                    <div className="col-md-2 form-group">
                      <label htmlFor="bet-history-to">To</label>
                      <input id="bet-history-to" className="form-control" type="date" min={from} value={to} onChange={(event) => setTo(event.target.value)} />
                    </div>
                    <div className="col-md-2 form-group">
                      <label htmlFor="bet-history-client">Client Name</label>
                      <AsyncSelect inputId="bet-history-client" cacheOptions defaultOptions loadOptions={searchClient} onChange={setUserName} isClearable value={userName} />
                    </div>
                    <div className="col-md-12 report-load-row">
                      <button type="button" className="btn btn-diamond" disabled={loading} onClick={() => { setPage(0); loadBetHistory(); }}>{loading ? "Loading..." : "Load"}</button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="report-table-toolbar">
                <label>Show <select value={size} onChange={(event) => { setSize(Number(event.target.value)); setPage(0); }}><option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option></select> entries</label>
              </div>
              <div className="table-responsive data-table">
                <table className="table table-bordered datatable dataTable clean-report-table bet-history-table">
                  <thead><tr><th>S.No.</th><th>Event Name</th><th>Runner Name</th><th>Bet Type</th><th className="number-column">User Rate</th><th className="number-column">Profit Loss</th><th className="number-column">Amount</th><th>Place Date</th><th>Match Date</th></tr></thead>
                  <tbody>
                    {rows.length === 0 ? <tr><td colSpan={9} className="dataTables_empty">{loading ? "Loading history..." : "No data available in table"}</td></tr> : rows.map((item, index) => (
                      <tr key={item.betId || item.id || index} className={item.betType === "Back" ? "back-bet-row" : "lay-bet-row"}>
                        <td>{page * size + index + 1}</td><td>{item.event_name}</td><td>{item.runner_name}</td><td>{item.betType}</td><td className="number-column">{item.userRate}</td><td className="number-column">{item.profitLoss}</td><td className="number-column">{item.amount}</td>
                        <td>{item.created_date ? moment(`${item.created_date}Z`).utc().local().format("DD/MM/YYYY HH:mm") : "-"}</td><td>{item.match_date ? moment(`${item.match_date}Z`).utc().local().format("DD/MM/YYYY HH:mm") : "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="clean-report-pagination">
                <button type="button" disabled={page === 0} onClick={() => setPage(0)}>«</button><button type="button" disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button><span>{page + 1}</span><button type="button" disabled={totalPages === 0 || page + 1 >= totalPages} onClick={() => setPage(page + 1)}>›</button><button type="button" disabled={totalPages === 0 || page + 1 >= totalPages} onClick={() => setPage(totalPages - 1)}>»</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
